import React, { useEffect, useState } from 'react';
import {
  Grid,
  Row,
  Column,
  Button,
  IconChevronRight,
  Divider,
  BUTTON_VARIANTS,
  IconChevronLeft,
  SimpleTableWrapper,
  SimpleTableBody,
  SimpleTableData,
  IconButton,
  Checkbox,
  IconEdit,
  SimpleTableToolbar,
  SimpleTableToolbarButtons,
  SimpleTableHeaderButton,
  IconViewList,
} from 'cdk-radial';
import {
  FullWidthTableData,
  StickySimpleTable,
  StickySimpleTableContainer,
  StyledCenterDiv
} from '../../common/StyledComponents';
import PartsDetailsTableHeaders from './PartsDetailsTableHeaders';
import { drop, truncate } from 'lodash';
import { ZebraSimpleTableRow } from '../../common/styled';
import { partItem } from '../../common/types';
import fetchDropDownData from '../../adapters/services/fetchDropDownData';
import getEmptyForNull from '../../utils/utils';
import { useOktaAuth } from '@okta/okta-react';



export default function PartOrderDetailsWrapper(props: any): JSX.Element {



  const [isBulkUpdatedDisabled, setIsBulkUpdatedDisabled] = useState(false);
  const [selectedRows, setSelectedRows] = useState<partItem[]>([]);
  const { authState } = useOktaAuth();
  const [dropDownData,setdropDownData] =useState([]);

  useEffect(() => {

    fetchDropDownData( `Bearer ${getEmptyForNull(
      authState?.accessToken?.accessToken
    )}`).then((data: any) => {
       setdropDownData(data);                                
    });
    console.log(dropDownData);
    let tempData: partItem[] = [];
    props.selectedOrders.forEach((order: any) => {
      order.partsEipResponseDTOS.forEach((item: any,index :number) => {
        if (item.isPartValid)
          tempData.push({ ...item, "orderNumber": order.orderNumber, "isSelected": false ,"index" :index});
      })
    })
    setSelectedRows(tempData);
   
    

    
  }, []);

  useEffect(() => {
    // Ensure selectedRows is an array and contains objects with isSelected
    if (Array.isArray(selectedRows) && selectedRows?.length > 0) {
      // Count the number of selected rows with isSelected === true
      const selectedCount = selectedRows.filter((row: any) => row.isSelected).length;
      setIsBulkUpdatedDisabled(selectedCount < 2);
    } else {
      setIsBulkUpdatedDisabled(true);
    }
  }, [selectedRows]);

  const handleCheckboxChange = (row: partItem, orderNumber: string) => {
    setSelectedRows((prevSelectedRows: any) => {
      const updatedRows = prevSelectedRows.map((r: any) => {
        const isTargetRow = r.partNumber === row.partNumber && r.orderNumber === orderNumber;
        return isTargetRow ? { ...r, isSelected: !r.isSelected } : r;
      });     
      const rowExists = prevSelectedRows.some(
        (r: any) => r.partNumber === row.partNumber && r.orderNumber === orderNumber
      );
  
      return rowExists ? updatedRows : [...updatedRows, { ...row, isSelected: true }];
    });
  };
  
  return (
    <Grid>
      <Row style={{ paddingLeft: '5px', paddingBottom: "0px" }}>
        <h4>Review order items, and update them as needed by OEM</h4>
      </Row>
      <Row>
        <SimpleTableWrapper
          style={{
            width: '100%'
          }}
        >
          <SimpleTableToolbar style={{ padding: "0px" }}>
            <SimpleTableToolbarButtons style={{ display: "flex", justifyContent: "flex-start", padding: "0px 0px 6px 0px" }}>
              <SimpleTableHeaderButton>
                <Button
                  dataTestId="bulk-update-button"
                  iconColor="primary"
                  icon={<IconViewList />}
                  onClick={(e: any) => {
                    props.BulkUpdateClick(selectedRows);
                  }}
                  size="standard"
                  text="Bulk Update"
                  variant="primary"
                  isDisabled={isBulkUpdatedDisabled}
                />
              </SimpleTableHeaderButton>
            </SimpleTableToolbarButtons>
          </SimpleTableToolbar>
          <StickySimpleTableContainer style={{ height: '500px' }}>
            <StickySimpleTable aria-label="Table">
              <PartsDetailsTableHeaders setSelectedRows={setSelectedRows} selectedRows={selectedRows} />
              <SimpleTableBody>
                {props.selectedOrders.length === 0 ? (
                  <FullWidthTableData colSpan={13}>
                    <StyledCenterDiv>No valid Parts to show.</StyledCenterDiv>
                  </FullWidthTableData>
                ) : (
                  props.selectedOrders.map((order: any, index: number) => {
                    return order.partsEipResponseDTOS.map((partItem: any) => {
                      return (
                        <ZebraSimpleTableRow>
                          <SimpleTableData colSpan={0}>
                            <Checkbox
                              checked={Array.isArray(selectedRows) && selectedRows.find((r: any) =>
                                (r.partNumber === partItem.partNumber && r.isSelected && r.orderNumber === order?.orderNumber))}
                              onChange={() => {
                                handleCheckboxChange(partItem, order.orderNumber);
                              }}
                              dataTestId={`checkbox-${'select'}`}
                            />
                          </SimpleTableData>
                          <SimpleTableData colSpan={1}>
                            {order?.orderNumber} {partItem.isPartValid}
                          </SimpleTableData>
                          <SimpleTableData colSpan={1}>
                            
                          </SimpleTableData>
                          <SimpleTableData style={{ whiteSpace: 'nowrap', }} colSpan={1}>
                            {partItem.partNumber}
                          </SimpleTableData>
                          {/* <SimpleTableData  colSpan={1}>
                              {partItem?.orderType}
                            </SimpleTableData> */}
                          <SimpleTableData colSpan={1} title={partItem?.partDesc}>
                            {truncate(partItem?.partDesc)}
                          </SimpleTableData>
                          <SimpleTableData colSpan={1}>
                            {partItem?.orderQty ? partItem?.orderQty : 1}
                          </SimpleTableData>
                          <SimpleTableData colSpan={1}>
                            {partItem?.price}
                          </SimpleTableData>
                          {/* <SimpleTableData  colSpan={1}>
                              {partItem?.dtnaCustomerName || ''}
                            </SimpleTableData> */}
                          <SimpleTableData colSpan={2}>
                            {partItem?.serialNumber || ''}
                          </SimpleTableData>
                          <SimpleTableData colSpan={1}>
                            {partItem?.vin || ''}
                          </SimpleTableData>
                          <SimpleTableData colSpan={1}>
                            {partItem?.pdc || ''}
                          </SimpleTableData>
                          <SimpleTableData colSpan={2}>
                          {(partItem.vdiFlag?.trim() === 'X') ? 'Yes' : ''}
                          </SimpleTableData>
                          <SimpleTableData colSpan={0} textAlign="right">
                            <IconButton
                              ariaLabel="edit"
                              // onClick={() => }
                              onClick={() => {
                                props.handlePartEditClick(partItem);
                              }}
                              icon={<IconEdit style={{ zIndex: "5", margin: "0px" }} />}
                              style={{ margin: "0px" }}
                              data-testid={`edit-button-${partItem.partNumber}`}
                            />
                          </SimpleTableData>
                        </ZebraSimpleTableRow>
                      );
                    });
                  })
                )}
              </SimpleTableBody>
            </StickySimpleTable>
          </StickySimpleTableContainer>
        </SimpleTableWrapper>
      </Row>
      <Divider style={{opacity:"70%"}}></Divider>
      <Grid>
        <Row>
          <Column l={8} m={12} s={12} xl={8} xs={12}>
            <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
              <Button
                iconColor="primary"
                style={{ backgroundColor: '#E8F1FC' }}
                data-testid="stepper-back-button"
                text="Previous"
                icon={<IconChevronLeft />}
                onClick={() => props.setActiveState(props.activeState - 1)}
                variant={BUTTON_VARIANTS.TEXT}
              />
            </div>
          </Column>
          <Column l={4} m={12} s={12} xl={4} xs={12}>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                iconColor="primary"
                icon={<IconChevronRight />}
                data-testid="stepper-next-button"
                text={'Next'}
                onClick={() => props.setActiveState(props.activeState + 1)}
                isIconTrailing
              />
            </div>
          </Column>
        </Row>
      </Grid>
    </Grid>
  );
}
